import { useState } from "react";
import { MapPin } from "lucide-react";

/** Center photo with a designed, text-free fallback when no photo exists or it fails to load. */
export function CenterImage({ src, alt, className = "" }: { src?: string; alt: string; className?: string }) {
  const [failed, setFailed] = useState(false);
  if (!src || failed) {
    return (
      <div
        role="img"
        aria-label={alt}
        className="relative grid h-full w-full place-items-center overflow-hidden bg-[radial-gradient(circle_at_30%_20%,color-mix(in_oklab,var(--primary)_28%,transparent)_0%,transparent_60%),linear-gradient(160deg,var(--carbon-deep,oklch(0.16_0.01_40))_0%,oklch(0.1_0.01_40)_100%)]"
      >
        <div className="absolute inset-0 opacity-20 [background-image:repeating-linear-gradient(135deg,var(--primary)_0_1px,transparent_1px_14px)]" />
        <div className="relative grid size-16 place-items-center rounded-full border border-primary/40 bg-primary/10 text-primary shadow-[0_0_30px_-8px_var(--primary)]">
          <MapPin className="size-7" strokeWidth={1.5} />
        </div>
      </div>
    );
  }
  return <img src={src} alt={alt} loading="lazy" onError={() => setFailed(true)} className={className} />;
}
